import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getEquipment = id => {
  return dispatch => {
    dispatch({ type: "GET_EQUIPMENT_LOADING" });
    api
      .equipmentGet(id)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetEquipmentErrorAlertTitle",
          "Virhe välineistön tai käyttöoikeuden lukemisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_EQUIPMENT_SUCCEEDED",
  payload: { equipment: data },
});

const operationFailed = () => ({
  type: "GET_EQUIPMENT_FAIL"
});
